<script setup>
import { setPageTitle } from '@/@core/utils/pageMetaUtils'

setPageTitle(PageMeta.Auth.notAuthorized.title)
definePage({ meta: PageMeta.Auth.notAuthorized.meta })

import { useAuthStore } from '@/@vxapp/Auth/useAuthStore'
import page401 from '@images/pages/401.png'
import miscMaskDark from '@images/pages/misc-mask-dark.png'
import miscMaskLight from '@images/pages/misc-mask-light.png'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)

const router = useRouter()
const auth = useAuthStore()
async function onLogout() {
  await auth.logout(router)
}
function onBack() {
  router.back()
}

/* ********* */
</script>

<template>
  <div class="misc-wrapper">
    <div class="misc-center-content text-center mb-12">
      <!-- 👉 Title and subtitle -->
      <h4 class="text-h4 font-weight-medium mb-3">You are not authorized! 🔐</h4>
      <p>You don't have permission to access this page. Go Home!</p>
      <VRow>
        <VCol cols="12">
          <VBtn @click="onBack">Back to Previous Page</VBtn>
        </VCol>

        <VCol cols="12">
          <VBtn to="/">Back to Home</VBtn>
        </VCol>

        <VCol cols="12">
          <VBtn @click="onLogout">Logout</VBtn>
        </VCol>
      </VRow>
    </div>

    <!-- 👉 Image -->
    <div class="misc-avatar w-100 text-center">
      <VImg
        :src="page401"
        alt="Coming Soon"
        :max-width="170"
        class="mx-auto"
      />
    </div>

    <VImg
      :src="authThemeMask"
      class="misc-footer-img d-none d-md-block"
    />
  </div>
</template>

<style lang="scss">
@use '@core/scss/template/pages/misc.scss';
</style>
